import {
  numberLessThan4,
  requiredTextLine,
  textDescription,
  textLine,
  notEmpty,
  lengthCount,
  withoutSpecialCharacters,
  positiveNumber,
  isInteger,
  maxLengthNumber
} from '@/modules/_global/variables/rules';

export default {
  data: () => ({
    rules: {
      name: requiredTextLine,
      rooms: numberLessThan4,
      floor: textLine,
      access_description: textDescription,
      key: [notEmpty, lengthCount(10), withoutSpecialCharacters],
      emergency_key: [positiveNumber, isInteger, maxLengthNumber(12)]
    }
  })
};
